module.exports = __webpack_public_path__ + "static/scene-cafe-7378c88c43502cfb1434afd3b130d7e0.jpg";